// Library Methods
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import Alert from "src/components/shared/alerts/Alert/Alert";
import D15VisionLines from "./D15VisionLines/D15VisionLines";
import D15Options from "./D15Options/D15Options";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

// Constants
import { examCardEnums } from "src/constants/enums";

// Utils
import { isTerminatedExamReport } from "src/utils/exams/examReportsHelper";

const D15Graph = () => {
  const { t } = useTranslation();

  const { exam } = useContext(ReportContext);
  const { examReport } = useContext(ReportSectionContext);

  const isTerminated = useMemo(
    () =>
      isTerminatedExamReport({
        exam,
        examReport,
        sectionName: examCardEnums.COLOR_VISION.sectionName,
      }),
    [exam, examReport]
  );

  return (
    <Grid container>
      {isTerminated && (
        <Alert
          variant="error"
          alertContent={t("Terminated Exam")}
          props={{ width: "100%" }}
        />
      )}

      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <D15VisionLines stateData={examReport.state} />
      </Grid>
      <D15Options data={examReport} />
    </Grid>
  );
};

export default D15Graph;
